import * as React from 'react';
import { ApIcon, colors } from '@alixpartners/ui-components';
import {
  HeaderDropdownLabelContainer,
  HeaderDropdownLabelText,
} from './HeaderDropdown.styles';

export interface IHeaderDropdownLabelProps {
  isOpen?: boolean;
  disabled?: boolean;
  children: React.ReactNode;
}

const HeaderDropdownLabel = React.forwardRef<
  HTMLButtonElement,
  IHeaderDropdownLabelProps
>(({ children = '', isOpen, disabled, ...rest }, ref) => (
  <HeaderDropdownLabelContainer {...rest} ref={ref}>
    <HeaderDropdownLabelText>{children}</HeaderDropdownLabelText>
    <ApIcon
      iconName="caret"
      iconColor={isOpen && !disabled ? colors.grey7 : colors.grey3}
    />
  </HeaderDropdownLabelContainer>
));

export default HeaderDropdownLabel;
